import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {Icon, Table, Card, Input, Button, Popup} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {paths} from '../../../common/dictionaries/urls';

class OriginsList extends Component {
  componentDidMount() {
    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.Origins,
        scopes.See
      )
    ) {
      this.props.navigateTo(paths.AccessDenied);
      return;
    }
    this.props.changeOriginTextFilter('');
    this.props.loadOrigins();
  }

  onFilterChange(event) {
    this.props.changeOriginTextFilter(event.target.value);
    this.props.filterOrigins(event.target.value);
  }

  renderCreateButton() {
    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.Origins,
        scopes.Create
      )
    ) {
      return null;
    }
    return (
      <Button primary className='toyota-primary' as={Link} to='/origenes/nuevo'>
        Añadir Nuevo
      </Button>
    );
  }

  render() {
    const {origins, filterText} = this.props;
    return (
      <div className='origins-list'>
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <h2>Mantenimiento de Orígenes</h2>
              <div className='title-bar-actions'>
                <Input
                  icon='search'
                  placeholder='Buscar'
                  value={filterText}
                  onChange={this.onFilterChange.bind(this)}
                />
                {this.renderCreateButton()}
              </div>
            </div>
          </div>
        </Card>

        <Card fluid raised>
          <Table striped className='toyota-grid'>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell textAlign='center'>Código</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>Origen</Table.HeaderCell>
                {hasAccessPermission(
                  this.props.permissions,
                  resources.Origins,
                  scopes.Edit
                ) && (
                  <Table.HeaderCell textAlign='center'>
                    Acciones
                  </Table.HeaderCell>
                )}
              </Table.Row>
            </Table.Header>

            <Table.Body>{this.renderOrigins(origins)}</Table.Body>
          </Table>
        </Card>
      </div>
    );
  }

  renderOrigins(list) {
    return list.map((element, index) => {
      return (
        <Table.Row key={index}>
          <Table.Cell textAlign='center'>{element.code}</Table.Cell>
          <Table.Cell textAlign='center'>{element.origin}</Table.Cell>
          {hasAccessPermission(
            this.props.permissions,
            resources.Origins,
            scopes.Edit
          ) && (
            <Table.Cell textAlign='center'>
              <Popup
                trigger={
                  <Link to={`/origenes/editar/${element.code}`}>
                    <Icon name='write' color='blue' size='large' />
                  </Link>
                }
                content='Editar'
                position='top center'
                inverted
              />
            </Table.Cell>
          )}
        </Table.Row>
      );
    });
  }
}

const mapStateToProps = (state) => {
  return {
    'origins': state.origin.filteredList,
    'filterText': state.origin.filterText,
    'menuSelected': state.menu.selected,
    'permissions': state.session.permissions,
  };
};

const {loadOrigins, filterOrigins, changeOriginTextFilter, navigateTo} = Actions;

export default connect(mapStateToProps, {
  loadOrigins,
  filterOrigins,
  changeOriginTextFilter,
  navigateTo,
})(OriginsList);
